/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllUsersDto } from '../../models/all-users-dto';

export interface GetAllUsers$Params {
  userId?: string;
  emailId?: string;
}

export function getAllUsers(http: HttpClient, rootUrl: string, params?: GetAllUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'statusCode'?: number;
'body'?: Array<AllUsersDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, getAllUsers.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('emailId', params.emailId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'statusCode'?: number;
      'body'?: Array<AllUsersDto>;
      }>;
    })
  );
}

getAllUsers.PATH = '/api/v1/all';
